const EULA  = [

<section class="terms-and-conditions">
 <p>

Please read this End-User License Agreement ("Agreement") carefully before downloading or playing Kepithor Applications("Application").<br /><br />

By downloading or using the Application, you are agreeing to be bound by the terms and conditions of this Agreement.<br /><br />

If you do not agree to the terms of this Agreement, do not download or use the Application.
</p>
<br />
<h3>License</h3>
<p>
Kepithor Studios grants you a revocable, non-exclusive, non-transferable, limited license to download, install and use the Application solely for your personal, non-commercial purposes strictly in accordance with the terms of this Agreement.
</p>
<br />
	
<h3>Restrictions</h3>
<p>
You agree not to, and you will not permit others to:<br /><br />

a) license, sell, rent, lease, assign, distribute, transmit, host, outsource, disclose or otherwise commercially exploit the Application or make the Application available to any third party.
</p>
	
<br />
<h3>Modifications to Application</h3>
<p>
Kepithor Studios reserves the right to modify, suspend or discontinue, temporarily or permanently, the Application or any service to which it connects, with or without notice and without liability to you.
</p>
<br />
	
<h3>Exploitation</h3>
<p>
Taking advantage of any possible exploit rather than reporting such a bug to Kepithor Studios is strictly prohibited and a breach of these terms.
</p>
<br />
	
<h3>Automation of Play</h3>
<p>
Automating play by any means is strictly prohibited and a breach of these terms.
</p>
<br />
	
<h3>Multiple Accounts</h3>
<p>
Creating multiple accounts or operating multiple accounts at the same time is strictly prohibited and a breach of these terms.<br />
Accounts flagged as multi-accounting will have 4 weeks to complete KYC.<br />
If not completed within that time the account will be closed and any KKT added to the following seasons prizepool.
</p>
<br />	

<h3>Friend Groups</h3>
<p>
We welcome and encourage friends to enjoy our games together. However, each player must operate their own account independently:<br />
- All item trades must be conducted through NFT marketplaces (Such as NFT.io).<br />
- Transferring assets directly between accounts is strictly prohibited.<br /><br />

Any users found violating these rules may be flagged for multi-accounting.
</p>
<br />

<h3>Inactive Email Addresses</h3>
<p>
Accounts made with inactive email addresses may be deleted and any associated assets forfeited.
</p>
<br />
	
<h3>Withdrawals</h3>
<p>
Kepithor Studios reserves the right to deny withdrawal features for you if Kepithor Studios believes you are breaching any of these terms. Any assets you have on account are thus account bound and virtual only.
</p>
<br />
	
<h3>Account Banning</h3>
<p>
Kepithor Studios reserves the right to ban players and/or deny features to anyone breaching any of these terms. You understand that breaching these terms may result in your assets being made account bound.
</p>
<br />
	
<h3>Inappropriate Player Names</h3>
<p>
Kepithor Studios reserves the right to change the username of any account with an inappropriate username.

Inappropriate usernames include usernames which are:
- Obscene/racist.
- Advertising other products/services.
- Exposing real-life contact details.
</p>
<br />
	
<h3>Competitions</h3>
<p>
Kepithor Studios frequently holds promotional competitions and reserves the right to cancel them at any time Kepithor Studios deems necessary. Players that competed in cancelled competitions are not entitled to compensation, however Kepithor Studios may choose to provide compensation at their discretion.
</p>
<br />
	
<h3>Term and Termination</h3>
<p>
This Agreement shall remain in effect until terminated by you or Kepithor Studios. <br /><br />

Kepithor Studios may, in its sole discretion, at any time and for any or no reason, suspend or terminate this Agreement with or without prior notice.<br /><br />

This Agreement will terminate immediately, without prior notice from Kepithor Studios, in the event that you fail to comply with any provision of this Agreement. You may also terminate this Agreement by deleting the Application and all copies thereof from your mobile device or from your desktop.<br /><br />

Upon termination of this Agreement, you shall cease all use of the Application and delete all copies of the Application from your mobile device or from your desktop.
</p>
<br />
	
<h3>Severability</h3>
<p>
If any provision of this Agreement is held to be unenforceable or invalid, such provision will be changed and interpreted to accomplish the objectives of such provision to the greatest extent possible under applicable law and the remaining provisions will continue in full force and effect.
</p>
<br />
	
<h3>Amendments to this Agreement</h3>
<p>
Kepithor Studios reserves the right, at its sole discretion, to modify or replace this Agreement at any time and do not need to provide prior notice to any new terms taking effect. 
</p>
<br />
	
<h3>Contact Information</h3>
<p>
If you have any questions about this Agreement, please contact us.<br />

</p>
<br />

<br />






</section>


];
export default EULA ;